import React, { useContext, useEffect, useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Box, Snackbar } from "@mui/material";

import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { OperacoesCulturaisForm } from "./operacoesculturais";
import { ManeioEPecuarioForm } from "./maneio";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { get } from "../../../Services/tokenConfig";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { func_print } from "../../../Func_genericas/func_print";
import { Alert } from "../../../Components/Alert/Alert";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { useLocation } from "react-router-dom";
import { FilterByData } from "../../../Func_genericas/filter_by_data";
import { IOperacoesCulturais } from "../../../Interfaces/cadernos/caderno5/interfaces5C";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(1),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);


export default function RegAtividPP() {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const location = useLocation();



  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>();
  const [especie_ou_lote_homegenio_selecionada_1, set_especie_ou_lote_homegenio_selecionada_1] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_selecionada_2, set_especie_ou_lote_homegenio_selecionada_2] = useState<IZonaHomogenea>();


  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = React.useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);


  const [rows, setRows] = useState<IOperacoesCulturais[]>([]);
  const [rows_filtrada, setRows_filtrada] = useState<IOperacoesCulturais[]>([]);


  async function getListaZonasHomogeneas() {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, `/zona_homgenea_caraterizacao/${location.state.id_rosto}`);

      if (res.status === 200) {
        set_especie_ou_lote_homegenio_selecionada_1(res.data.result[0]);
        set_especie_ou_lote_homegenio_selecionada_2(res.data.result[0]);
        set_especie_ou_lote_homegenio_lista(res.data.result);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("getCabecalhoFitossanitaria", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    (async () => {
      await getListaZonasHomogeneas();
    })();
  }, []);

  return (
    <div className={classes.root}>
      <CadernoLayout title="5C - Registo das Atividades pastagens permanentes e pastagens biodiversas" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />
        <div>
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>

          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>

          <Box width="80%" margin="auto">
            <BeneficiarioNomeIdAlinhadoDireita />
          </Box>

          <FilterByData
              listas={[
                {
                  lista_original: rows,
                  set_lista_filtrada: setRows_filtrada,
                  campoData: "data",
                },
               
              ]}
            />

          <OperacoesCulturaisForm
            set_especie_ou_lote_homegenio_selecionada={set_especie_ou_lote_homegenio_selecionada_1}
            especie_ou_lote_homegenio_lista={especie_ou_lote_homegenio_lista}
            especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada_1}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setMessage={setMessage}
            setOpenSnackError={setOpenSnackError}
            setOpenSnackSuccess={setOpenSnackSuccess}
            rows={rows}
            rows_filtrada={rows_filtrada}
            setRows={setRows}
            setRows_filtrada={setRows_filtrada}
          />

          <ManeioEPecuarioForm

            set_especie_ou_lote_homegenio_selecionada={set_especie_ou_lote_homegenio_selecionada_2}
            especie_ou_lote_homegenio_lista={especie_ou_lote_homegenio_lista}
            especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada_2}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setMessage={setMessage}
            setOpenSnackError={setOpenSnackError}
            setOpenSnackSuccess={setOpenSnackSuccess}

          />


        </div>
      </main>
    </div>
  );
}
